const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgBice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be31ff2b-6474-4569-aa57-811c434eb783",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bc0efc80-1484-4a6a-b725-3f0a17c2f5f9{fill:#2d5f97;}.e71820f5-6e7d-441f-a534-82635372e6fa{fill:#fff;}")), /*#__PURE__*/React.createElement("rect", {
    className: "bc0efc80-1484-4a6a-b725-3f0a17c2f5f9",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "e71820f5-6e7d-441f-a534-82635372e6fa",
    d: "M11,11H41v4.12H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e71820f5-6e7d-441f-a534-82635372e6fa",
    d: "M41,19.64v4.1H11v-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e71820f5-6e7d-441f-a534-82635372e6fa",
    d: "M11,32.39V28.28H41v4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e71820f5-6e7d-441f-a534-82635372e6fa",
    d: "M11,41V36.91H41V41Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBice);
export default __webpack_public_path__ + "static/media/BICE.a4379a2f0fbcd3fee1b1cd08806f06f6.svg";
export { ForwardRef as ReactComponent };